/*
 * @Author: zhangkun
 * @Date: 2024-02-23 10:20:13
 * @LastEditTime: 2026-01-13 14:27:39
 * @LastEditor: zhangkun
 * @Description:
 */

import { httpClient } from "@/assets/js/http";
import urls from "@/api/urls";
import conf from "@/config/index";

function getFundTypes() {
    return httpClient.get("/api/v1/fund/eventype", { __mock: false });
}

// 基金精选模块请求方法，可自定义接口
function getFundRecommended(url, data) {
    return httpClient.get(url, data);
}

/// 查询首页 基金主题 数据
function getThemeFunds() {
    return httpClient.post(urls.bannerAds, { bannertype: 3 }); // TODO: 类型待定
}

/// 查询基金列表
export function combCalPlanModle(data = {}) {
    return httpClient.post(urls.combCalPlanModle, data);
}

/// 查询基金列表
export function getFundLists(data = {}) {
    return httpClient.post(urls.fundList, data);
}

/// 查询已交易的基金列表
export function queryProdTradedList(data = {}) {
    return httpClient.post(urls.queryProdTradedList, data);
}

/// 查询基金详情
function getFundDetails(data = {}) {
    // console.log("详情接口入参", data)
    return httpClient.post(urls.fundDetail, data);
}

// 查询基金策略类型
function getFundStrategyType(data = {}) {
    return httpClient.post(urls.qryFundStrategyType, data);
}

// 获取协议
function qryFundReadFile(data = {}) {
    return httpClient.post(urls.qryFundReadFile, data);
}

// 文件阅读留痕
function fileReadRecord(data = {}) {
    return httpClient.post(urls.fileReadRecord, data);
}

/// 查询基金标签
function getFundLabels() {
    return httpClient.get("/api/v1/trade/fund/tag", { __mock: false });
}

// 查询基金历史净值/收益
function getNavHistoryList(data = {}) {
    // data.__mock = true
    // console.log("getNavHistoryList, params: " + JSON.stringify(data))
    return httpClient.post(urls.fundNavHistory, data);
}

// 查询新品基金
function getNewFunds() {
    return httpClient.post(urls.newFunds);
}

// 查询基金净值
function getFundNavHistory(url, fundCode, startDate, endDate, isAsc = "0") {
    return httpClient.post(url, {
        fundcode: fundCode,
        startdate: startDate,
        enddate: endDate,
        isasc: isAsc
    });
}

// 查询基金公告
function getAnnouncement(params = {}) {
    return httpClient.post(urls.qryProductExtService, params);
}

// 查询公告详情
function getNoticeDetail(params = {}) {
    return httpClient.post(urls.qryFundNoticeDetailService, params);
}

function qrySysNotice(params = {}) {
    return httpClient.post(urls.qrySysNotice, params);
}

// 查询基金费率
function qryFundFeeService(data) {
    return httpClient.post(urls.qryFundFeeService, data);
}

// 查询认/申购/赎回/转换费用
export function qryTransFee(data) {
    return httpClient.post(urls.qryTransFee, data);
}

// 查询基金交易流程时间节点信息
function qryTransDateInfo(data) {
    return httpClient.post(urls.qryTransDateInfo, data);
}

// 查询历届基金经理信息
function qryFundManagers(data) {
    return httpClient.post(urls.fundManagers, data);
}

// 查询持仓基金列表 qryAssetTotal
export function getHoldingAssets(data = {}) {
    return httpClient.post(urls.assetList, data);
}

// 查询持仓基金分页列表
function getAssetsList(data) {
    return httpClient.post(urls.qryAsset, data);
}

// 查询专户资产
function qrySpecialAsset(data) {
    return httpClient.post(urls.qrySpecialAsset, data);
}

// 购买前查询
function qryBeforeBuy(data) {
    return httpClient.post(urls.qryTransInfo, data);
}

// 银行卡/汇款/现金宝购买下单
function fundBuyOrderPay(data, option) {
    return httpClient.post(urls.fundBuyOrderPay, data, option);
}

// 交易申请查询
function combQueryTransValidList(data) {
    return httpClient.post(urls.combQueryTransValidList, data);
}
// 交易分红查询
function qryDividendInfo(data) {
    return httpClient.post(urls.qryDividendInfo, data);
}

// 查询协议信息
function combQueryAcctElecontract(data) {
    return httpClient.post(urls.combQueryAcctElecontract, data);
}

// 查询客户电子合同信息
function queryCustAcctElecontractFile(data) {
    return httpClient.post(urls.queryCustAcctElecontractFile, data);
}

// 查询交易流水
function qryOrderListService(params) {
    return httpClient.post(urls.orderList, params);
}

// 查询代销交易流水
function qryCrmTransConfirm(params) {
    return httpClient.post(urls.dxOrderList, params);
}

// 查询交易流水详情
function qryOrderDetailService(params) {
    return httpClient.post(urls.orderDetail, params);
}

// 页面/短信/代扣支付接收
function codeReceivePay(data) {
    return httpClient.post(urls.codeReceivePay, data);
}

// 赎回前查询
function qryBeforeRedeem(data) {
    return httpClient.post(urls.qryBeforeRedeem, data);
}

// 赎回持仓基金
function redeemAsset(data) {
    return httpClient.post(urls.redeem, data);
}

// 查询可撤单记录
export function cancelOrderList() {
    return httpClient.post(urls.cancelableOrderList);
}

// 撤单
export function cancelOrder(data) {
    return httpClient.post(urls.cancelOrder, data);
}

// 转换前查询
function queryTradeConvertInfo(data = {}) {
    return httpClient.post(urls.tradeConvertInfoService, data);
}

// 转换下单
function tradeConvert(data = {}) {
    return httpClient.post(urls.tradeConvert, data);
}

// 产品适当性检查
export function sdxCheck(params = {}) {
    return httpClient.post(urls.sdxCheck, params);
}

// 适当性协议
export function getProtocol(params = {}) {
    return httpClient.post(urls.sdxProtocol, params);
}

// 修改分红方式
function tradeDivideModify(params = {}) {
    return httpClient.post(urls.tradeDivideModify, params);
}
// 批量修改分红方式
function batchTradeDivideModify(params = {}) {
    return httpClient.post(urls.batchTradeDivideModify, params);
}
// 定投前查询
function tradePlan(params = {}) {
    return httpClient.post(urls.tradePlanInfo, params);
}

// 定投开通
function planOpen(params = {}) {
    return httpClient.post(urls.acctPlanOpen, params);
}

// 查询我的定投
function getPlan(params = {}) {
    return httpClient.post(urls.acctPlan, params);
}

// 定投暂停/恢复/终止
function planOperation(params = {}) {
    return httpClient.post(urls.acctPlanOperation, params);
}

// 客户定投汇总信息查询
function qryPlanTotalInfo() {
    return httpClient.post(urls.qryPlanTotalInfo);
}

// 查询定投详情历史扣款
function qryAppTransService(params = {}) {
    return httpClient.post(urls.qryAppTransService, params);
}

// 查询销售机构
function qryProductOrgService(fundcode) {
    return httpClient.post(urls.qryProductOrgService, { fundcode: fundcode });
}
// 查询历史收益
function qryHistoryProfit(params = {}) {
    return httpClient.post(urls.qryHistoryProfit, params);
}

// 交易限额查询
function combQueryFundlimit(params = {}) {
    return httpClient.post(urls.combQueryFundlimit, params);
}
// 惩罚性费用查询
function combQueryHoldDayDetail(params = {}) {
    return httpClient.post(urls.combQueryHoldDayDetail, params);
}
// 反洗钱黑名单查询
function qryBlackListService(params = {}) {
    return httpClient.post(urls.qryBlackListService, params);
}
// 高龄客户限制查询
function qryOldercustLimitService(params = {}) {
    return httpClient.post(urls.qryOldercustLimitService, params);
}

// 查询基金产品类型
function qryFundClass(params = {}) {
    return httpClient.post(urls.fundList, params);
}

// 交易前流动性检查
function combTransLiquidityCheck(params = {}) {
    return httpClient.post(urls.combTransLiquidityCheck, params);
}

// 适当性协议处理
function warnProcessHandler(data = {}) {
    return httpClient.post(urls.baseWarnProcessHandler, data);
}

// 获取pdf文件base64数据
function getPdfBase64(params = {}) {
    return httpClient.get(urls.base64, params);
}

// 查询业务是否需要验证交易密码
function queryValidPwdTrdMethod() {
    return httpClient.post(urls.queryValidPwdTrdMethod, {
        acceptmethodstr: conf.systemtype
    });
}

// 转换限额查询
function combQueryTargetFundLimit(data = {}) {
    return httpClient.post(urls.combQueryTargetFundLimit, data);
}

// 关注基金列表
function qryCollectFund(data = {}) {
    return httpClient.post(urls.qryCollectFund, data);
}

// 关注基金
function collectFund(data = {}) {
    return httpClient.post(urls.collectFund, data);
}

// 取消关注基金
function unCollectFund(data = {}) {
    return httpClient.post(urls.unCollectFund, data);
}

// 查询查询现金宝信息
function cfgFundrealtimeQueryAll(params = {}) {
    return httpClient.post(urls.cfgFundrealtimeQueryAll, params);
}
// 赎回转购限额查询
function combTransRedeemForBuyLimit(params = {}) {
    return httpClient.post(urls.combTransRedeemForBuyLimit, params);
}

// 实时TA购买
function combTransRealtaRedeemForBuy(params = {}) {
    return httpClient.post(urls.combTransRealtaRedeemForBuy, params);
}

// 赎回转购买
function combTransRedeemForBuy(params = {}) {
    return httpClient.post(urls.combTransRedeemForBuy, params);
}

// 赎回转申购-转入目标基金列表
function combQueryTransRedeemForBuyList(params = {}) {
    return httpClient.post(urls.combQueryTransRedeemForBuyList, params);
}

// 实时TA赎回/快赎
function combTransRealtaRedeem(params = {}) {
    return httpClient.post(urls.combTransRealtaRedeem, params);
}

// 普通购买使用省钱购下单
function combTransBuy(data = {}) {
    return httpClient.post(urls.combTransBuy, data);
}
// 现金宝充值
function combTransRealtaBuy(data = {}) {
    return httpClient.post(urls.combTransRealtaBuy, data);
}

// 跨系统转托管
function combTrusteeAll(data = {}) {
    return httpClient.post(urls.combTrusteeAll, data);
}

// 转托管转入
function combTrusteeIn(data = {}) {
    return httpClient.post(urls.combTrusteeIn, data);
}

// 查询基金组合资产
function qryStrategyAsset(data = {}) {
    return httpClient.post(urls.qryStrategyAsset, data);
}

// 查询组合的基金占比情况
function qryStrategyFundRatio(data = {}) {
    return httpClient.post(urls.qryStrategyFundRatio, data);
}

// 查询组合调仓记录
function qryStrategyAdjust(data = {}) {
    return httpClient.post(urls.qryStrategyAdjust, data);
}

// 每期调仓的基金情况
function qryStrategyAdjustDetail(data = {}) {
    return httpClient.post(urls.qryStrategyAdjustDetail, data);
}

// 查询组合信息
function qryCombinationInfo(data = {}) {
    return httpClient.post(urls.qryCombinationInfo, data);
}

// 组合定投新增/删除/修改/终止
function combInvestPlanManager(data = {}) {
    return httpClient.post(urls.combInvestPlanManager, data);
}

// 获取风险权限规则
function queryApproMatchRules(data = {}) {
    return httpClient.post(urls.queryApproMatchRules, data);
}

// 获取页面支付结果
function payInform(data = {}) {
    return httpClient.post(urls.payInform, data);
}

// 查询份额明细列表(到期日汇总)
function combQueryShortShareDetailTotal(data = {}) {
    return httpClient.post(urls.combQueryShortShareDetailTotal, data);
}

// 现金宝充值完成后查询交易状态
function combQueryRealTransStatus(data = {}) {
    return httpClient.post(urls.combQueryRealTransStatus, data);
}

// 查询系统交易日
function qeryCfgSysconfigExt(data = {}) {
    return httpClient.post(urls.qeryCfgSysconfigExt, data);
}

// 查询TA信息
function queryCfgTaInfos(data = {}) {
    return httpClient.post(urls.queryCfgTaInfos, data);
}

// 购买前校验
function checkComplianceService(data = {}) {
    return httpClient.post(urls.checkComplianceService, data);
}

// 判断基金列表是否查询私募产品
function qryModuleParamService(data = {}) {
    return httpClient.post(urls.qryModuleParamService, data);
}
// 查询业务文件
function qryBusinessFile(data) {
    return httpClient.post(urls.qryBusinessFile, data);
}

// 查询定投协议
export function combQueryAgrPlan(data) {
    return httpClient.post(urls.combQueryAgrPlan, data);
}

// 实时TA撤单
export function combTransRealtaCancel(data) {
    return httpClient.post(urls.combTransRealtaCancel, data);
}

export default {
    getFundTypes,
    getFundRecommended,
    getThemeFunds,
    getFundLists,
    queryProdTradedList,
    getFundStrategyType,
    qryFundReadFile,
    fileReadRecord,
    getFundDetails,
    getFundLabels,
    getNavHistoryList,
    getNewFunds,
    getFundNavHistory,
    getAnnouncement,
    getNoticeDetail,
    qrySysNotice,
    getHoldingAssets,
    getAssetsList,
    qrySpecialAsset,
    qryBeforeBuy,
    fundBuyOrderPay,
    combQueryTransValidList,
    qryOrderListService,
    qryCrmTransConfirm,
    qryOrderDetailService,
    codeReceivePay,
    qryBeforeRedeem,
    redeemAsset,
    qryTransDateInfo,
    qryTransFee,
    qryFundFeeService,
    cancelOrderList,
    cancelOrder,
    qryFundManagers,
    sdxCheck,
    getProtocol,
    tradeDivideModify,
    batchTradeDivideModify,
    tradePlan,
    planOpen,
    getPlan,
    planOperation,
    qryPlanTotalInfo,
    qryAppTransService,
    qryProductOrgService,
    qryHistoryProfit,
    combQueryFundlimit,
    combQueryHoldDayDetail,
    qryBlackListService,
    qryOldercustLimitService,
    qryFundClass,
    combTransLiquidityCheck,
    warnProcessHandler,
    getPdfBase64,
    queryValidPwdTrdMethod,
    queryTradeConvertInfo,
    tradeConvert,
    combQueryTargetFundLimit,
    qryCollectFund,
    collectFund,
    unCollectFund,
    qryDividendInfo,
    cfgFundrealtimeQueryAll,
    combTransRedeemForBuyLimit,
    combQueryTransRedeemForBuyList,
    combTransRealtaRedeemForBuy,
    combTransRedeemForBuy,
    combTransRealtaRedeem,
    combCalPlanModle,
    combTransBuy,
    combTrusteeAll,
    qryStrategyAsset,
    qryStrategyFundRatio,
    qryStrategyAdjust,
    qryStrategyAdjustDetail,
    qryCombinationInfo,
    combInvestPlanManager,
    combTransRealtaBuy,
    queryApproMatchRules,
    payInform,
    combQueryShortShareDetailTotal,
    combQueryRealTransStatus,
    qeryCfgSysconfigExt,
    queryCfgTaInfos,
    checkComplianceService,
    combTrusteeIn,
    qryModuleParamService,
    combQueryAcctElecontract,
    queryCustAcctElecontractFile,
    qryBusinessFile,
    combQueryAgrPlan,
    combTransRealtaCancel
};
